<style lang="less">

</style>

<template>
  <div id="main" style="width: 100%;  height: 100%">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data () {
    return {};
  },
  mounted () { },
  beforeDestroy () { },
  methods: {}
};
</script>



// WEBPACK FOOTER //
// src/App.vue